// todo: i think we might need to create this as real adapter too
export { TimerEvent } from "@awayjs/core";
